import 'css-chunksrc/client/common/preview/styles.scss';export default {
  "preview": "_preview_1djy6_1"
};